import { CircularProgress } from '@material-ui/core';
import { colors } from '../../../assets/colors';

export const Spinner = (props: any) => <CircularProgress {...props} style={{ color: colors.gray }} />;
